import { useAsync } from "@react-hookz/web";
import { useEffect, useRef } from "react";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";
import { createOperationDescriptor, type Disposable, getRequest } from "relay-runtime";

import { useEditionValue } from "scmp-app/lib/edition";
import type {
  hooksBurgerMenuTopicsQuery,
  hooksBurgerMenuTopicsQuery$variables,
} from "scmp-app/queries/__generated__/hooksBurgerMenuTopicsQuery.graphql";

export const useBurgerMenuTopics = () => {
  const environment = useRelayEnvironment();
  const currentEdition = useEditionValue();
  const disposableReference = useRef<Disposable>();

  const [{ result: data, status }, { execute }] = useAsync(async () => {
    const query = graphql`
      query hooksBurgerMenuTopicsQuery($name: String!) {
        queue(filter: { name: $name }) {
          items(first: 10) {
            edges {
              ...topicsMenuItemQueueItemsEdge
            }
          }
        }
      }
    `;
    const variables: hooksBurgerMenuTopicsQuery$variables = {
      name: `related_topic_homepage_${currentEdition}_`,
    };

    const queryRequest = getRequest(query);
    const queryDescriptor = createOperationDescriptor(queryRequest, variables);

    const data = await fetchQuery<hooksBurgerMenuTopicsQuery>(
      environment,
      query,
      variables,
    ).toPromise();
    disposableReference.current = environment.retain(queryDescriptor);
    return data;
  });

  useEffect(() => {
    if (status !== "not-executed") return;
    void execute();
    return () => {
      disposableReference.current?.dispose();
    };
  }, [execute, status]);

  return data?.queue?.items?.edges ?? [];
};
